// :cow: Cosmose CONFIDENTIAL :iso:
export const getBaseSpyLineChart = (): any => {
  const greyColor = 'rgba(255, 255, 255, 0.5)';

  return {
    data: {
      labels: undefined,
      datasets: undefined,
    },
    type: 'SpyLine',
    options: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: 0,
        },
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false,
            color: greyColor,
            lineWidth: 0.3,
          },
          ticks: {
            fontColor: greyColor,
            padding: 15,
            maxTicksLimit: 8,
            maxRotation: 0,
          },
        }],
        yAxes: [{
          gridLines: {
            color: greyColor,
            lineWidth: 0.3,
            zeroLineColor: greyColor,
            drawBorder: false,
          },
          ticks: {
            beginAtZero: true,
            padding: 15,
            fontColor: greyColor,
            min: 0,
          },
        }],
      },
      legend: {
        display: false,
      },
      hover: {
        mode: 'index' as any,
        intersect: false,
      },
      tooltips: {
        intersect: false,
        enabled: false,
        mode: 'index' as any,
        custom: undefined,
      },
    },
  };
};
